// 2023-11-24 - Code migrated from peoplePickerManager.js

function setPairProperties(entity, userEntityData) {
    var dataPairs = entity ? Object.keys(entity) : [];

    if (!dataPairs.length) {
        return;
    }

    dataPairs.forEach(function (key) {
        userEntityData[key] = entity[key];
    });
}

function getPeoplePickerObject(entity) {
    const { DisplayText, Key } = entity;
    const Email = entity.Email || entity.EntityData?.Email;

    var userEntityData = {
        id: Key,
        value: Key,
        text: DisplayText + (Email ? ` ‹${Email}›` : ''),
        AccountId: Key,
        DisplayName: DisplayText,
        IsResolved: entity.IsResolved,
        Description: entity.Description,
        EntityType: entity.EntityType,
        ProviderName: entity.ProviderName,
    };

    setPairProperties(entity.EntityData, userEntityData);

    return userEntityData;
}

function sortPeoplePickerData(user1, user2) {
    if (user1.Email < user2.Email) {
        return 1;
    }

    if (user1.Email > user2.Email) {
        return -1;
    }

    return 0;
}

function processUsersData(userList) {
    if (!userList || !userList.length) {
        return [];
    }

    var users = userList.map(getPeoplePickerObject);

    users.sort(sortPeoplePickerData);

    return users;
}

const makePeopleSearcher = (shpAccess, siteUrl) => {
    const searchPeople = async (searchPattern, searchPeopleOnly, maxCount) => {
        const result = await shpAccess.searchPeoplePickerUserAsync(
            siteUrl,
            searchPattern,
            searchPeopleOnly,
            maxCount,
        );

        // TODO - handle this result checking within forms-shared
        if (!result.success) {
            throw new Error(
                result.error.Message ||
                    'Unspecified error when searching for people.',
            );
        }

        return processUsersData(JSON.parse(result.data));
    };

    return { searchPeople };
};

export default makePeopleSearcher;
